import React from "react";
import Styles from "./styles.module.scss";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

import docIcon from '../../../theme/assets/svg/tc_cab_capsule_anketa_icon.svg';
import galleryIcon from '../../../theme/assets/svg/tc_cab_capsule_materials_icon.svg';
import uploadIcon from '../../../theme/assets/svg/tc_cab_capsule_upload_icon.svg';

import {setCapsuleFilesModalStatus} from "../../../store/cabinet/action";
import {isCapsuleLocked, isCapsuleSealed} from "../../../helpers/capsule";

const CabinetCapsuleMaterials = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const capsuleStats = useSelector(store => store.cabinet.capsuleStats);

    const files = capsuleStats?.stats?.files;
    // percent теперь про объём хранилища, а не про количество файлов
    const isFull = (files?.percent || 0) >= 100;
    // пока капсула не куплена, раздел закрыт
    const isLocked = isCapsuleLocked(capsuleStats?.capsule_status);
    // запечатанную капсулу уже не дополняют: раздел открывается только на чтение
    const isSealed = isCapsuleSealed(capsuleStats?.capsule_status);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetPC}`}>
                <div className={`${Styles.cardWrap} ${Styles.border3dOuterXl}`}>
                    {/* декоративная стопка иконок из макета */}
                    <div className={`${Styles.decorWrap} ${isLocked ? Styles.decorWrapLocked : ''}`} aria-hidden="true">
                        <div className={`${Styles.decorItem} ${Styles.decorItem_0}`}>
                            <img src={docIcon} alt=""/>
                        </div>
                        <div className={`${Styles.decorItem} ${Styles.decorItem_1}`}>
                            <img src={galleryIcon} alt=""/>
                        </div>
                        <div className={`${Styles.decorItem} ${Styles.decorItem_2}`}>
                            <img src={uploadIcon} alt=""/>
                        </div>
                    </div>

                    <div className={`${Styles.cardHead}`}>
                        <div className={`${Styles.cardTitle}`}>{t('Памятные материалы')}</div>
                    </div>

                    <div className={`${Styles.cardNote}`}>
                        {t('Здесь вы можете загрузить ваши памятные материалы, которые сможете передать кому угодно')}
                    </div>

                    <div
                        className={`${Styles.cardBtn} ${isLocked || isSealed ? Styles.cardBtnDsb : ''}`}
                        onClick={()=>{
                            if (!isLocked && !isSealed && capsuleStats){
                                dispatch(setCapsuleFilesModalStatus(true));
                            }
                        }}
                    >
                        {isSealed ? t('Запечатано') : (isFull && !isLocked ? t('Хранилище заполнено') : t('Загрузить файлы'))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetCapsuleMaterials;
